<template>
  <ResponsiveLayout
    sticky-actions
    :progress="progress"
    :show-lang-picker="false"
  >
    <template #header_start>
      <ButtonBack @click="emit('back')" />
    </template>
    <template #header_middle>
      <div class="kds-typography-title-medium">
        {{ $t('b2b_self_test_generic_assessment') }}
      </div>
    </template>
    <div class="kds-main-wrapper">
      <div class="kds-content-block">
        <h3
          class="kds-typography-title-xlarge"
          v-html="$t('b2b__self_test__msk_us__past_medication__header')"
        />
        <div
          class="kds-typography-paragraph-large"
          v-html="$t('b2b__self_test__msk_us__past_medication__description')"
        />
      </div>
      <div class="self-test">
        <fieldset>
          <div
            v-for="item in items"
            :key="item.key"
            :class="[
              'quiz-checkbox',
              { 'quiz-checkbox--checked': isChecked(item) },
            ]"
            @click="handleCheckboxChange(item)"
          >
            <label class="quiz-checkbox__label kds-typography-title-medium">
              {{ $t(item.value) }}
            </label>
            <div class="quiz-checkbox__layout">
              <CustomCheckbox
                :checked="isChecked(item)"
                :data-q-a="item.key"
                :value="item.key"
              />
            </div>
          </div>
        </fieldset>
      </div>
    </div>
    <template #actions>
      <BaseButton
        :text="interactiveButtonText"
        :variant="interactiveButtonCSSClasses"
        data-qa="submit"
        @click="handleNextEvent()"
      />
    </template>
  </ResponsiveLayout>
</template>

<script setup>
import CustomCheckbox from '@shared/components/CustomCheckbox.vue'
import BaseButton from '@shared/components/BaseButton.vue'
import pastMedicationsList from '@shared/modules/assessment/config/past-medications.json'
import { useI18n } from 'petite-vue-i18n'
import { computed, ref } from 'vue'
import useSelfTestReevaluationStore from '@shared/modules/assessment/stores/useSelfTestReevaluationStore.js'
import ResponsiveLayout from '@shared/components/ResponsiveLayout.vue'
import ButtonBack from '@shared/components/ButtonBack.vue'

const reevaluationsStore = useSelfTestReevaluationStore()
const { t } = useI18n()

defineProps({
  progress: {
    type: Number,
    default: null,
  },
  handleNextEvent: {
    type: Function,
    default: () => {},
  },
})

const emit = defineEmits(['back'])

const items = ref(pastMedicationsList.concat([]))

const selectedPastMedications = computed(
  () => reevaluationsStore.selectedPastMedications,
)

const interactiveButtonText = computed(() =>
  selectedPastMedications.value.length > 0
    ? t('generic_action_continue')
    : t('b2b__self_test__msk_us__past_medication__none_of_these'),
)

const interactiveButtonCSSClasses = computed(() =>
  selectedPastMedications.value.length > 0 ? 'primary' : 'outlined',
)

const handleCheckboxChange = (item) => {
  let items = selectedPastMedications.value.concat([])
  if (items.includes(item.key)) {
    items = items.filter((i) => i !== item.key)
  } else {
    items.push(item.key)
  }
  reevaluationsStore.selectedPastMedications = items
}

const isChecked = (item) => selectedPastMedications.value.includes(item.key)
</script>

<style lang="scss">
@use '@shared/modules/assessment/views/css/SelfTest.scss' as *;
</style>
